export const authQueryKeys = {
  checkIfResetPasswordTokenIsValid: (token: string) =>
    ["check-reset-password-token-is-valid", token] as const,
  checkIfVerifyTokenIsValid: (token: string, email: string) =>
    ["check-verify-email-token-is-valid", token, email] as const,
};
